import { getCommunityDetailQueryKey } from '@pba/react-network';
import { useQueryClient } from '@tanstack/react-query';
import { Entity } from 'models';
import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services/api';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: Break circular dependency
import { getProfileQueryKey } from 'features/users/queries/keys';
import { leaveCommunity } from '../../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Failed to leave community.');
};

export const useLeaveCommunity = () => {
  const queryClient = useQueryClient();

  return useMutation<Entity, { id: string }>({
    defaultMutateOnError,
    async mutationFn({ id }) {
      const communityResponse = await leaveCommunity({ routeParams: { id } });

      return new Entity(communityResponse.data);
    },
    async onError(_error, { id }) {
      await queryClient.invalidateQueries({ queryKey: getCommunityDetailQueryKey({ id }) });
    },
    async onSuccess(_data, { id }) {
      await queryClient.invalidateQueries({ queryKey: getCommunityDetailQueryKey({ id }) });
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
